export default "__VITE_ASSET__BPXndj8W__"